/* eslint react-hooks/exhaustive-deps: 0 */

import { Container, FormControl, FormControlLabel, Grid, makeStyles, Radio, RadioGroup, TextField, Typography, Button, withStyles, useMediaQuery, Theme, Link, Select, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { isEmail,  isFullWidthKana, isNumber, isLetter, isACMNumber } from '../../../../../utils/regExpUtils';
import scClick from '../../../../common/ScClick';
import { submitReservation } from '../../../../../services/taxi/Reservation';
import { ReservationParams } from '../../../../../services/taxi/Reservation/ReservationParams';
import { Alert } from '@material-ui/lab';
import Environment from '../../../../../utils/environment';
import Cost from './../common/Cost';
import AlertInReservation from '../../MiyakoTaxi/AlertInReservation';
import { ReservationLabels, ReservationResponse } from '../../../../../services/taxi/Reservation/ReservationResponse';
import { useForm } from './Form/useForm';

import SelectChildrenNum from './Form/SelectChildrenNum';
import SelectAdultNum from './Form/SelectAdultNum';
import SelectCarNum from './Form/SelectCarNum';
import SelectOtherBag from './Form/SelectOtherBag';
import SelectSuitcase from './Form/SelectSuitcase';
import SelectGolfBag from './Form/SelectGolfBag';
import LoadingModal from '../../../../search/LoadingModal';
import { switchisLoading } from '../../../../../actions/generalAction';
import { useDispatch } from 'react-redux';
import Cautions from '../common/Cautions';
import Contact from '../common/Contact';

import { AlertLabel, TaxiCompanyList } from '../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { TaxiCompanyConfiguration } from '../../../../../services/taxi/GetTaxiMetaInfo/model/taxiCompanyConf';
import ShowTaxiComapnyLogo from '../TemporaryReservation/ShowTaxiComapnyLogo';
import { changeLang, Lang } from '../../../../../states/query';
import { useTranslation } from 'react-i18next';
import { getSCCkickType } from '../TemporaryReservation/Form/useForm';
import { parseFromyyyyMMddHHmm, toLuxonDateTime } from '../../../../../utils/luxonUtil';
import {
  isMileageCampaignTargetCompany,
  isMileageCampaignActive,
  isMileageCampaignOriginalSupported,
  getMileageCampaignPdfUrl,
  CURRENT_MILEAGE_CAMPAIGN,
} from '../campaign/mileageCampaign';

const useStyles = makeStyles(() => ({
  forms: {
    marginBottom: "5px"
  },
  notes: {
    color: '#ff0000',
    fontSize: '0.75em'
  },
  tableLeft: {
    backgroundColor: "#000066",
    color: "#FFF",
    fontSize: '0.75rem',
    border: 'solid 1px #000',
    padding: '0.5rem 0'
  },
  tableRight: {
    fontSize: '0.75rem',
    border: 'solid 1px #000',
    padding: '0.5rem 5px',
  },
  tableFlex: {
    display: 'flex',
    alignItems: 'center',
  },
  formControl: {
    display: 'flex',
    fontSize: '0.5rem',
    flexDirection: 'row',
    margin: 'auto'
  },
  date: {
    wordBreak: 'keep-all',
    display: 'flex'
  },
  timeSelect: {
    height: '1rem',
    width: '3.0rem',
    fontSize: '0.75rem'
  },
  mailForm: {
    alignItems: 'baseline',
    padding: '0 5px'
  },
  mailText: {
    fontSize: '0.75rem'
  },
  disableMaileTaxt: {
    fontSize: '0.75rem',
    background: '#cccccc'
  },
  button: {
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.30)',
    borderRadius: '2px',
    textAlign: 'center',
    width: '100%',
    height: '48px',
    margin: '16px 0',
  },
  itemName: {
    color: "#ffffff",
    fontSize: "0.75rem",
  },
  text: {
    color: "#000000",
    fontSize: "0.75rem",
  },
  validationAlert: {
    marginTop: "5px",
    padding: "5px",
  },
  costNotice: {
    color: '#f44336',
    textAlign: 'center'
  },
  imgContainer: {
    alignItems: 'flex-start',
  },
  easternLogo: {
    margin: '10px 0px',
    width: '100%',
    maxHeight: '156px',
  },
  link: {
    textDecoration: 'underline'
  }
}));

/** 背景色を黄色、ラベル色を黒にしたボタンのコンポーネント。 */
const YellowButton = withStyles({
  root: {
    backgroundColor: "#FDB50A",
  },
  label: {
    color: "#0f0f0f",
  },
})(Button);


/** 予約情報のうち、距離・所要時間・金額を表示する部分の文字列。 */
export const reservationTransferInfo = (reservationLabels: ReservationLabels) => {
  const distanceLabel = reservationLabels.distanceLabel;
  const timeLabel = reservationLabels.durationLabel;
  const fareLabel = reservationLabels.fareLabel;
  return `${distanceLabel} ${timeLabel} ${fareLabel}`
}

interface Props {
  /** 仮予約情報。 */
  reservation?: ReservationResponse,
  /** 仮予約情報を参照するためのコード。 */
  code: string,
  /** 仮予約情報を参照するためのトークン。 */
  token: string,
  /** タクシー会社メタ情報 */
  taxiCompanyConf: TaxiCompanyConfiguration,
  /** タクシー会社情報 */
  taxiCompany: TaxiCompanyList,
  /** デバッグモードかどうかのフラグ */
  isDebug: boolean
}

/** 空港送迎タクシーの本予約画面のフォーム部分のコンポーネント。 */
export const AirportTransferTaxi: React.FC<Props> = (props: Props) => {
  /** 実行環境を判別するための環境変数。 */
  const env = process.env['REACT_APP_STAGE_ENV'] || '';
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { i18n, t } = useTranslation();
  const isMobileSize = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  const {
    requestCount, setRequestCount,
    isFailed, setIsFailed,
    isRequiredRetry, setIsRequiredRetry,
    isUnavalableEmail, setIsUnavalableEmail,
    isInvalidInput, setIsInvalidInput,
    lastName, setLastName,
    firstName, setFirstName,
    lastNameKana, setLastNameKana,
    firstNameKana, setFirstNameKana,
    placard, setPlacard,
    carType, setCarType,
    adultNum, onChangeAdultNum,
    childNum, onChangeChildNum,
    carNum, onChangeCarNum,
    phoneNumber, setPhoneNumber,
    suitcase, onChangeSuitcase,
    maxSuitcase,
    golfBag, onChangedGolfBag, maxGolfBag,
    otherBag, onChangeOtherBag,
    payment, setPayment,
    receiptAddress, setReceiptAddress,
    remarks, setRemarks,
    operatorMailaddress, setOperatorMailaddress,
    acmMileageNumber, setAcmMileageNumber,
    reservationFare, setReservationFare,
    reservationLabels, setReservationLabels,
    setMaxSuitcasePerUnit, setMaxGolfBagPerUnit,
    setmaxSuitcase, setMaxGolfBag,
    mailUndeliveredProblemReproduction, setMailUndeliveredProblemReproduction
  } = useForm();

  // バリデーションで利用する各フラグのState。
  // 入力された値が適切ではない場合。
  const [isInvalidLastName, setIsInvalidLastName] = useState(false);
  const [isInvalidFirstName, setIsInvalidFirstName] = useState(false);
  const [isInvalidLastNameKana, setIsInvalidLastNameKana] = useState(false);
  const [isInvalidFirstNameKana, setIsInvalidFirstNameKana] = useState(false);
  const [isInvalidPhoneNumber, setIsInvalidPhoneNumber] = useState(false);
  // 領収書で使用する文字列チェック（現在はチェックなし）
  // const [isInvalidReceiptAddress, setIsInvalidReceiptAddress] = useState(false);
  const [isInvalidOperatorMailaddress, setIsInvalidOperatorMailaddress] = useState(false);
  const [isInvalidACMNumber, setIsInvalidACMNumber] = useState(false);

  // 入力された値のうち、必須項目が未設定であることを表すフラグ。
  const [isEmptyLastName, setIsEmptyLastName] = useState(false);
  const [isEmptyFirstName, setIsEmptyFirstName] = useState(false);
  const [isEmptyLastNameKana, setIsEmptyLastNameKana] = useState(false);
  const [isEmptyFirstNameKana, setIsEmptyFirstNameKana] = useState(false);
  const [isEmptyPhoneNumber, setIsEmptyPhoneNumber] = useState(false);

  /** プラカードの項目で字数制限を越えている（51文字以上）かを表すフラグ。 */
  const [isTooLongPlacard, setIsTooLongPlacard] = useState(false);

  /** 備考は500文字以内かを表すフラグ */
  const [isTooLongRemarks, setInTooLongRemarks] = useState(false);

  /** 仮予約情報。 */
  const reservation = props.reservation;
  /** 仮予約情報を参照するためのコード。 */
  const code = props.code;
  /** 仮予約情報を参照するためのトークン。 */
  const token = props.token;
  /** 空港着の送迎パターンであるかを表すフラグ。 */
  const isToAirport = reservation?.flight?.isDeparture;
  /** 車種が復数かつ車種によって金額が異なる場合の注釈を表示するか */
  const isShowNotesByDifferenceOfTariffs: boolean = (()=>{
    const tariffs = props.reservation?.transferInfo?.tariffs;
    if(!tariffs) {
      return false;
    }
    /** 車種が1つだけのときには表示しない */
    if(Object.keys(tariffs).length < 2) {
      return false;
    }
    /** 車種ごとの料金一覧 */
    const fares = Object.keys(tariffs).map((x)=>{
      return tariffs[x].fare?.value;
    })
    // 重複を排除した上で料金種類が2種類以上のときには表示する
    return Array.from(new Set(fares)).length > 1;
  })()
  /** 遷移先GoogleMapURL */
  const setGoogleMapURL = (latlng: string = "", lang: Lang) => {
    if(lang === Lang.ja) {
      return `https://www.google.co.jp/maps?q=${latlng}`;
    }
    return `https://www.google.com/maps?q=${latlng}`;
  }

  const airportNoteLabel = t('taxi:detail_meeting_point_infomation');

  // 結果画面からの経由で来たか判定
  // airport_access: 空港アクセスナビから来たと判定
  // chatan: タクシー会社が那覇ハイヤーの場合のみ、北谷MaaSサイトから来たと判定。
  // それ以外: ASWから来たと判定（実際には referrer=asw で飛んでくる）
  const clickName = (()=>{
    const scClicks = props.taxiCompanyConf?.scClick.reservation;
    const clickType = getSCCkickType(props.reservation?.referrer);
    if(!scClicks) {
      return '';
    }
    return scClicks[clickType] || scClicks?.asw;
  })();

  /** 表示制御用のUI情報 */
  const ui = props.taxiCompanyConf.ui;

  /** 初回読み込み時のみ処理 */
  React.useEffect(() => {
    /** uiよりスーツケースの最大数をセットする */
    const suitcaseObj = ui.bags.find((x)=> x.id === 'suitcase');
    if(suitcaseObj && suitcaseObj.maxQuantity) {
      setMaxSuitcasePerUnit(suitcaseObj.maxQuantity);
      // スーツケースの個数の最大値を更新する。
      setmaxSuitcase(suitcaseObj.maxQuantity);
    }
    /** uiよりゴルフバッグの最大数をセットする */
    const golfBagObj = ui.bags.find((x)=> x.id === 'golfBag');
    if(golfBagObj && golfBagObj.maxQuantity) {
      setMaxGolfBagPerUnit(golfBagObj.maxQuantity);
      // スーツケースの個数の最大値を更新する。
      setMaxGolfBag(golfBagObj.maxQuantity);
    }
  }, []);

  /** タクシー会社のメールアドレスとして扱うメールアドレスが変更された場合の処理。 */
  const onChangedOperatorMailaddress = (value: string) => {
    setOperatorMailaddress(value);
  }

  const lastNameChange = (value: string) => {
    setLastName(value);
  }

  const firstNameChange = (value: string) => {
    setFirstName(value);
  }

  /**
   * 全角カナの名字の項目が更新された時の処理。
   * @param value テキストボックスで設定された値。
   */
  const onChangedLastNameKana = (value: string) => {
    setLastNameKana(value);
  }

  /**
   * 全角カナの名前の項目が更新された時の処理。
   * @param value テキストボックスで設定された値。
   */
  const onChangedFirstNameKana = (value: string) => {
    setFirstNameKana(value);
  }

  const phoneNumberChange = (value: string) => {
    setPhoneNumber(value);
  }

  const paymentChange = (value: string) => {
    setPayment(value);
  }

  const receiptAddressChange = (value: string) => {
    setReceiptAddress(value);
  }

  const remarksChange = (value: string) => {
    setRemarks(value)
  }

  /** プラカードの項目の値が更新された時の処理。 */
  const onChangedPlacard = (value: string) => {
    setPlacard(value);
  }

  /** 「名」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextLastName = () => {
    if (isEmptyLastName) { return t('taxi:warning_empty_lastname'); }
    if (isInvalidLastName) { return t('taxi:warning_invalid_lastname'); }
  }

  /** 「姓」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextFirstName = () => {
    if (isEmptyFirstName) { return t('taxi:warning_empty_firstname'); }
    if (isInvalidFirstName) { return t('taxi:warning_invalid_firstname'); }
  }

  /** 「メイ」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextLastNameKana = () => {
    if (isEmptyLastNameKana) { return "セイが入力されていません"; }
    if (isInvalidLastNameKana) { return "セイはカタカナで入力してください"; }
  }

  /** 「セイ」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextFirstNameKana = () => {
    if (isEmptyFirstNameKana) { return "メイが入力されていません" }
    if (isInvalidFirstNameKana) { return "メイはカタカナで入力してください"; }
  }

  /** 「携帯電話番号」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextPhoneNumber = () => {
    if (isEmptyPhoneNumber) { return t('taxi:warning_empty_phone_number'); }
    if (isInvalidPhoneNumber) { return t('taxi:warning_invalid_phone_number'); }
  }

  /** 「プラカード」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextPlacard = () => {
    if (isTooLongPlacard) { return t('taxi:warning_too_long_placard'); }
  }

  /** 「プラカード」の欄のヘルパーテキストをフラグに応じて取得する。 */
  const getHelperTextRemarks = () => {
    if (isTooLongRemarks) { return t('taxi:warning_too_long_remarks'); }
  }

  /** 自動車タイプより料金・ラベル情報を更新する */
  const setFareAndLabelsByCarType = (carType: string) => {
    const transferInfo = props?.reservation?.transferInfo;
    if(transferInfo && transferInfo.tariffs) {
      const fare = transferInfo.tariffs[carType]?.fare;
      if(fare) {
        setReservationFare(fare);
      }
      const labels = transferInfo.tariffs[carType]?.labels;
      if(labels) {
        setReservationLabels(labels);
      }
    }
  }

  /** 入力フォームで設定された各項目の検証をする。 */
  const validate = async() => {
    const isLangJa = i18n.language === 'ja'
    /** 「名」の空白チェック結果。 */
    const resultIsEmptyLastName = lastName === "";
    /** 「姓」の空白チェック結果。 */
    const resultIsEmptyFirstName = firstName === "";
    /** 「メイ」の空白チェック結果（日本語のみ） */
    const resultIsEmptyLastNameKana = lastNameKana === "" && isLangJa;
    /** 「セイ」の空白チェック結果（日本語のみ） */
    const resultIsEmptyFirstNameKana = firstNameKana === "" && isLangJa;
    /** 「携帯電話番号」の空白チェック結果。 */
    const resultIsEmptyPhoneNumber = phoneNumber === "";
    /** 「携帯電話番号」の空白チェック結果。 */
    const resultIsEmptyACMNumber = acmMileageNumber === "";

    /** 「名」の値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidLastName = (!resultIsEmptyLastName && !isLetter(lastName));
    /** 「姓」の値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidFirstName = (!resultIsEmptyFirstName && !isLetter(firstName));
    /** 「メイ」の値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidLastNameKana = isLangJa && (!resultIsEmptyLastNameKana && !isFullWidthKana(lastNameKana));
    /** 「セイ」の値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidFirstNameKana = isLangJa && (!resultIsEmptyFirstNameKana && !isFullWidthKana(firstNameKana));
    /** 「携帯電話番号」値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidPhoneNumber = (!resultIsEmptyPhoneNumber && !isNumber(phoneNumber));
    /** 「ACM番号」値のチェック結果。（空白の場合は除く。） */
    const resultIsInvalidACMNumber = (!resultIsEmptyACMNumber && !isACMNumber(acmMileageNumber))

    /** プラカードの項目の検証結果。 */
    // 任意項目であるため、設定されている場合のみ字数制限（50文字以下であるか）を検証する。
    const resultIsTooLongPlacard = (placard !== "" && placard.length > 50);

    /** 備考の項目の検証結果。 */
    // 任意項目であるため、設定されている場合のみ字数制限（500文字以下であるか）を検証する。
    const resultIsTooLongRemarks = (remarks !== "" && remarks.length > 500);

    /** 領収書宛名の項目の検証結果。 */
    // 任意項目であるため、設定されている場合のみ値を検証する。
    // 現在は領収書宛名の検証は行わない
    // const resultIsInvalidReceiptAddress = (receiptAddress !== "" && !isLetterWithSpace(receiptAddress));

    /** タクシー会社のメールアドレスとして扱うメールアドレスの検証結果。*/
    // 任意項目であるため、文字列が設定されている場合のみ値を検証する。
    const resultIsInvalidOperatorMailaddress = (operatorMailaddress !== "" && !isEmail(operatorMailaddress));

    // 必須項目の空白チェックの検証結果をStateにセットする。
    setIsEmptyLastName(resultIsEmptyLastName);
    setIsEmptyFirstName(resultIsEmptyFirstName);
    setIsEmptyLastNameKana(resultIsEmptyLastNameKana);
    setIsEmptyFirstNameKana(resultIsEmptyFirstNameKana);
    setIsEmptyPhoneNumber(resultIsEmptyPhoneNumber);

    // 代表者氏名の検証結果をStateにセットする。
    setIsInvalidLastName(resultIsInvalidLastName);
    setIsInvalidFirstName(resultIsInvalidFirstName);

    // 代表者氏名（全角カナ）での氏名の検証結果をStateにセットする。
    setIsInvalidLastNameKana(resultIsInvalidLastNameKana);
    setIsInvalidFirstNameKana(resultIsInvalidFirstNameKana);

    // 電話番号の検証。
    setIsInvalidPhoneNumber(resultIsInvalidPhoneNumber);

    // ACM番号の検証
    setIsInvalidACMNumber(resultIsInvalidACMNumber);

    // プラカードの項目の文字数の検証。
    setIsTooLongPlacard(resultIsTooLongPlacard);

    // 備考の文字数の検証
    setInTooLongRemarks(resultIsTooLongRemarks)

    // 領収書宛名の検証。（現在はチェックなし）
    // setIsInvalidReceiptAddress(resultIsInvalidReceiptAddress);
    // タクシー会社のメールアドレスとして扱うメールアドレスの検証。
    setIsInvalidOperatorMailaddress(resultIsInvalidOperatorMailaddress);

    // 上記の各項目を検証した結果のうち、1件以上true（検証を通らなかった項目）がある場合、false（入力に不備があること）を返す。
    if (resultIsEmptyLastName || resultIsEmptyFirstName || resultIsEmptyLastNameKana ||
        resultIsEmptyFirstNameKana || resultIsEmptyPhoneNumber ||
        resultIsInvalidLastName || resultIsInvalidFirstName ||
        resultIsInvalidLastNameKana || resultIsInvalidFirstNameKana ||
        resultIsInvalidPhoneNumber || resultIsTooLongPlacard ||
        resultIsInvalidOperatorMailaddress || resultIsTooLongRemarks ) {
      return false;
    // 上記の各項目の検証がいずれもfalse（検証を通った状態）であれば、true（入力に不備がないこと）を返す。
    } else {
      return true;
    }
  }

  /** 予約ボタンを押した時の処理。 */
  const onSubmit = () => {
    // デバッグモードでは予約処理が出来ないようにする。
    if(props.isDebug) {
      alert('デバッグモードでは予約処理を実行できません。');
      return;
    }
    // 処理中フラグをオンにする。
    dispatch(switchisLoading(true));

    // ダミータクシーの場合にはSCクリックを実行しない
    if(props.taxiCompany !== TaxiCompanyList.dummyVal) {
      // SCクリックの実行。（Adobe Analytics上でのクリック数の集計。）
      scClick(clickName);
    }

    // 各フラグをリセットする（オフにする）。
    // 予約処理に失敗したフラグをオフにする。
    setIsFailed(false);
    // 予約処理の再実行を促すフラグをオフにする。
    setIsRequiredRetry(false);
    // 設定されたメールアドレスが利用不可であるフラグをオフにする。
    setIsUnavalableEmail(false);
    // 入力内容に不備があるフラグをオフにする。
    setIsInvalidInput(false);

    // リクエスト回数が4回以上の場合、予約処理を実行しない。
    if (requestCount > 3) {
      // 利用できないメールアドレスであるフラグをオンにする。
      setIsUnavalableEmail(true);
      // 処理中フラグをオフにする。
      dispatch(switchisLoading(false));
      return;
    }

    // 無名関数内で各非同期処理を呼び出す。
    (async() => {
      // コード・トークンが未設定の場合はAPIへリクエストしない。
      if (!code || !token || code === null || token === null) {
        // 読込中フラグをオフにする。
        dispatch(switchisLoading(false));
        return;
      }

      /** フォームで入力されたすべての値の検証結果。 */
      // すべての項目で検証が通ればtrue（1件以上検証が通らなかった場合はfalse）となる。
      const validatedResult = await validate();

      // 本番環境ではoperatorMailaddressを無条件で空文字にします
      const sendOperatorMailaddress: string = (Environment.getEnvironmentType() !== Environment.PRODUCTION && operatorMailaddress !== undefined)? operatorMailaddress: '';
      // 本番環境では mailUndeliveredProblemReproduction を無条件でundefinedにします
      const sendMailUndeliveredProblemReproduction: string | undefined = (Environment.getEnvironmentType() !== Environment.PRODUCTION && mailUndeliveredProblemReproduction !== '')? mailUndeliveredProblemReproduction: undefined;

      // フォームの入力値のすべての項目の検証が通っている場合のみ、本予約APIへリクエストする。
      if (validatedResult) {
        /** 本予約APIへリクエストする際のパラメーター。 */
        // 領収書宛名が設定されている場合は、領収書宛名を含めたオブジェクト、
        // 領収書宛名が未設定の場合は、領収書宛名を除いたオブジェクトをリクエストパラメーターとする。
        let params: ReservationParams = {
          code: code,
          token: token,
          lastName: lastName,
          firstName: firstName,
          phoneNumber: phoneNumber,
          passengers: {
            adult: adultNum,
            child: childNum,
          },
          numOfCars: carNum,
          carType: carType,
          paymentMethod: payment,
          bags: {
            suitcase: suitcase,
            golfBag: golfBag,
            other: otherBag,
          },
          placard: placard,
          count: requestCount,
          receiptAddress: receiptAddress,
          remarks: remarks,
          operatorMailaddress: sendOperatorMailaddress,
          amc: acmMileageNumber,
          useTestAddress: sendMailUndeliveredProblemReproduction,
          // メール送信されないようにするためにはコメントアウトを外す
          // noSendMails: true,
          // 言語パラメーター
          language: i18n.language
        }
        if(lastNameKana && firstNameKana) {
          params = {
            ...params,
            lastNameKana: lastNameKana,
            firstNameKana: firstNameKana,
          }
        }
        /** 整形後のパラメーター。（送信不要な項目が存在する場合は削除した状態のパラメーター。） */
        const modifiedParams = await modifyParams(params);
        // 本予約APIにリクエストする。
        submitReservation(modifiedParams).then((response) => {
          /** ステータスコード。 */
          const statusCode = response?.status;
          /** 予約成功時に完了ページに送るパラメーター。 */
          const successParams = new URLSearchParams({
            company: props.taxiCompany,
            lang: i18n.language,
            referrer: props.reservation?.referrer ? props.reservation.referrer : '',
          });
          // ステータスコードに応じて設定する。
          switch(statusCode) {
            case 200:
              // 予約処理が成功した場合、予約完了ページに遷移する。
              history.push(`/booking-taxi/success?${successParams.toString()}`);
              break;
            case 400:
              // フォームの入力内容に不備があるフラグをtrueにする。
              setIsInvalidInput(true);
              break;
            case 499:
              // 別のメールアドレスを設定するよう促すフラグをtrueにする。
              setIsUnavalableEmail(true);
              break;
            case 599:
              // 予約処理の再実行を促すフラグをtrueにする。
              setIsRequiredRetry(true);
              // リクエスト回数をインクリメントする。
              setRequestCount(requestCount + 1);
              break;
            default:
              // 予約失敗フラグを設定する。
              setIsFailed(true);
              break;
          }
        }).catch(() => {
          // 何らかリクエスト処理に失敗した場合は、予約失敗フラグを設定する。
          setIsFailed(true);
        }).finally(() => {
          // 最後にかならず処理中フラグをオフにする。
          dispatch(switchisLoading(false));
        });
      } else {
        // フォームの入力値のいずれかの項目の検証が通らなかった場合。
        // 処理中フラグをオフにする。
        dispatch(switchisLoading(false));
        // 入力値に不備があるフラグをオンにする。
        setIsInvalidInput(true);
        return;
      }
    })();
  }

  /** 本予約APIへのリクエストパラメーターを整形する。 */
  const modifyParams = async(params: ReservationParams) => {
    // プラカードの値が未設定の場合は、パラメーターのオブジェクトに「姓」・「名」の値を設定する。
    if (params.placard === "") { params.placard = `${lastName} ${firstName}`; }
    /** 領収書宛名が未設定の場合は、パラメーターのオブジェクトから削除する。 */
    if (params.receiptAddress === "") { delete params.receiptAddress; }
    /** タクシー会社のメールアドレスとして扱うアドレスが未設定の場合は、パラメーターのオブジェクトから削除する。 */
    if (params.operatorMailaddress === "") { delete params.operatorMailaddress; }
    /** マイレージクラブ番号が空の場合には、パラメーターのオブジェクトから削除する */
    if (!params.amc || params.amc === "" ) { delete params.amc; }
    /** 備考欄が空の場合には、パラメーターのオブジェクトから削除する */
    if (!params.remarks || params.remarks === "" ) { delete params.remarks; }
    /** 本番環境では開発用パラメーターを削除する */
    if(process.env['REACT_APP_STAGE_ENV'] === 'master') {
      /** このメールアドレスがタクシー会社のメールアドレスとして使用され、予約情報などのメールがこちらに送信されるようになる。*/
      delete params.operatorMailaddress;
      /** メール送信が行わないようにするための設定 */
      delete params.noSendMails;
    }
    return params;
  }

  /** フライト時間の項目名のラベルを取得する。 */
  const getFlightTimeLabel = () => {
    let label = t('taxi:dep_time');
    // 予約情報の送迎パターンが「空港発」の場合は、「到着時間」を設定する。
    if (reservation && reservation.operation === 'dropOff') {
      label = t('taxi:arr_time');
    }
    return label;
  }

  /** コスト（所要時間・距離）のラベルを取得する。 */
  const costLabel = () => {
    if (!reservation) { return ''; }
    return `${reservationLabels?.distanceLabel} ${reservationLabels?.durationLabel}`;
  }

  /** 金額ラベルを取得する。 */
  const PriceLabel: React.FC = () => {
    if (!reservation || !reservationLabels.fareLabel) {
      return null;
    }
    // バックエンドから返ってきた料金ラベルをそのまま表示する
    return (
      <div>{reservationLabels.fareLabel}</div>
    )
  }

  /** 備考ラベルを表示する */
  const NotesLabel: React.FC = () => {
    if (!reservation || !reservationFare.notesLabel ) {
      return null;
    }
    return (
      <span data-cy="booking_taxi_notes_area">
        {reservationFare.notesLabel.map((noteLabel: string, index: number) => {
          return (
            <div key={index}>{noteLabel}</div>
          )
        })}
      </span>
    );
  }

  /** フォーム上に表示するお迎え日時。 */
  const rideDatetime = () => {
    const date = reservation ? parseFromyyyyMMddHHmm(reservation.rideDatetime) : undefined;
    const showDateFormat = date ? date.toFormat(t('taxi:yyyyMMdd')) : "";
    return `${showDateFormat} ${t('taxi:jst')}`;
  }

  const rideDate = () => {
    const date = reservation ? parseFromyyyyMMddHHmm(reservation.rideDatetime) : undefined;
    const showDateFormat = date ? date.toFormat('yyyy年MM月dd日') : "";
    return `${showDateFormat}`;
  }

  /** フォーム上に表示する搭乗便の便番号。 */
  const flightNumber = () => {
    const flight = reservation ? reservation.flight : undefined;
    return flight ? flight.number : "";
  }

  /** フォーム上に表示する搭乗便の発着時刻。 */
  const flightDate = () => {
    const flightDate = reservation ? parseFromyyyyMMddHHmm(reservation.flight.datetime) : undefined;
    const showDateFormat = flightDate ? flightDate.toFormat(t('taxi:yyyyMMdd')) : ""
    return `${showDateFormat} ${t('taxi:jst')}`;
  }

  /** 台数を表示する事業者か判定 */
  const isDisplayNumberOfCars = (taxiCompany: TaxiCompanyList): boolean => {
    /** 非表示にする事業者一覧 */
    return ![
      TaxiCompanyList.kingTaxi,
      TaxiCompanyList.sakataNo1Taxi,
      TaxiCompanyList.shokoHire,
      TaxiCompanyList.nikaho_go,
      TaxiCompanyList.airport_liner,
      TaxiCompanyList.iwakiTaxi
    ].includes(taxiCompany);
  }

  /** 車種選択欄を表示する事業者か */
  const isDisplayCarModel = (taxiCompany: TaxiCompanyList): boolean => {
    /** 非表示にする事業者一覧 */
    return ![
      TaxiCompanyList.sakataNo1Taxi,
      TaxiCompanyList.shokoHire,
      TaxiCompanyList.nikaho_go,
      TaxiCompanyList.airport_liner,
      TaxiCompanyList.iwakiTaxi
    ].includes(taxiCompany);
  }

  /**
   * 【AM-1152】空港送迎マイル増量キャンペーン（恒久モジュール）
   * 期間・対象会社・文言・PDFは src/.../campaign/mileageCampaign.ts の設定で管理。
   * 期間判定は日付ベースで自動ON/OFFされるため、本番反映タイミングに依存しない。
   */
  /** キャンペーン対象会社か */
  const isMileageCampaignTarget = isMileageCampaignTargetCompany(props.taxiCompany);
  /** キャンペーン期間中か（対象会社 かつ 期間内） */
  const isInMileageCampaign = isMileageCampaignTarget && isMileageCampaignActive(reservation?.rideDatetime);
  /** 通常マイルあり（元々AMC ON）の会社/空港か（PDF①/②の出し分けにも使用） */
  const isMileageOriginalSupported = isMileageCampaignOriginalSupported(
    props.taxiCompany,
    props.reservation?.airportInfo.letter,
  );

  /** タクシーメタ情報を元にしてACM(マイレージ情報)入力欄を表示するか */
  const isDisplayAMCInputTable = (): boolean => {
    // 【AM-1152】キャンペーン対象会社の処理
    if (isMileageCampaignTarget) {
      // キャンペーン期間中: 全対象会社でAMC表示
      if (isInMileageCampaign) {
        return true;
      }
      // キャンペーン期間外: もともとAMC ON の会社のみ通常ロジックへ進む。
      //                      キャンペーン専用（通常マイルなし）の会社は非表示
      if (!isMileageOriginalSupported) {
        return false;
      }
    }

    if(!props.taxiCompanyConf) {
      return false;
    }
    if(!props.taxiCompanyConf.supportAMC.includes(props.reservation?.airportInfo.letter || '')) {
      return false;
    }
    // メタ情報の中にAMC番号のサポート期間要素があるか
    if(props.taxiCompanyConf.supportAMCPeriod && reservation){
      const rideDate = parseFromyyyyMMddHHmm(reservation.rideDatetime);
      const supportPeriod = {
        start: toLuxonDateTime(props.taxiCompanyConf.supportAMCPeriod.start),
        end: toLuxonDateTime(props.taxiCompanyConf.supportAMCPeriod.end)
      }
      return rideDate >= supportPeriod.start && rideDate <= supportPeriod.end;
    }
    // サポート期間要素がない場合には常に表示する
    // サポート期間要素がある場合には、乗車日がサポート期間内にある場合のみ表示する
    return true;
  }

  useEffect(() => {
    // 初回読み込み時にデフォルトの車種を設定する
    const defaltCarType = ui?.carTypes?.[0]?.id;
    if(ui) {
      if(defaltCarType) {
        setCarType(defaltCarType);
      }
      // デフォルトの決済手段を配置する
      const defaultPayMethod = ui.paymentMethod?.[0]?.id;
      if(defaultPayMethod) {
        paymentChange(defaultPayMethod);
      }
    }
    if(props.reservation?.transferInfo) {
      const transferInfo = props.reservation.transferInfo;
      if(transferInfo.tariffConfirmed) {
        if(transferInfo.fare) {
          setReservationFare(transferInfo.fare);
        }
        if(transferInfo.labels) {
          setReservationLabels(transferInfo.labels);
        }
      }
      else {
        // 現在は車種しか想定していない
        if(transferInfo.tariffTypes === 'carTypes') {
          setFareAndLabelsByCarType(defaltCarType);
        }
      }
    }
  }, []);

  // 便接続の乗合タクシーかどうか
  const isFlightConnectionSharedTaxi = [TaxiCompanyList.sakataNo1Taxi, TaxiCompanyList.shokoHire, TaxiCompanyList.iwakiTaxi].includes(props.taxiCompany);

  /** 庄内エリアのタクシー会社か？ */
  const isShonaiAreaTaxi = [TaxiCompanyList.sakataNo1Taxi, TaxiCompanyList.shokoHire].includes(props.taxiCompany);

  /** 象潟合同のタクシー会社か？ */
  const isKisakataTaxi = [TaxiCompanyList.airport_liner, TaxiCompanyList.nikaho_go].includes(props.taxiCompany);

  /**
   * 山口県のタクシー会社か？
   * 対象：宇部山電タクシー、宇部構内タクシー、通津タクシー
  */
  const isYamaguchiTaxi = [
    TaxiCompanyList.ubeSanden,
    TaxiCompanyList.ubeKounai,
    TaxiCompanyList.tsuzutaxi
  ].includes(props.taxiCompany);

  /**
   * 福島県のタクシー会社か？
   * 対象：大和自動車交通、北福島タクシー、磐城タクシー
  */
  const isFukushimaTaxi = [
    TaxiCompanyList.daiwaj,
    TaxiCompanyList.kitafukushima,
    TaxiCompanyList.iwakiTaxi
  ].includes(props.taxiCompany);

  /**
   * マイルキャンペーンver1のタクシーか？
   * 対象：キングタクシー（kingtaxi2）、石川交通、那覇ハイヤー、別府大分合同タクシー、宮交タクシー
  */
  const isMileCampaignPhase1Taxi = [
    TaxiCompanyList.kingTaxi2,
    TaxiCompanyList.ishikawakotsu,
    TaxiCompanyList.nahahire,
    TaxiCompanyList.gotaku,
    TaxiCompanyList.miyakou
  ].includes(props.taxiCompany);

  /**
   * マイルキャンペーンver2のタクシーか？
   * 対象：旭川中央交通、函館タクシー、イースタン（羽田/成田）、伊予鉄タクシー（タクシー）、伊予鉄タクシー（ハイヤー）、土電ハイヤー
  */
  const isMileCampaignPhase2Taxi = [
    TaxiCompanyList.Asahikawachuuo,
    TaxiCompanyList.hakodateTaxi,
    TaxiCompanyList.limoTaxi,
    TaxiCompanyList.eastern,
    TaxiCompanyList.iyotetsutaxi,
    TaxiCompanyList.iyotetsuTaxi2,
    TaxiCompanyList.toden
  ].includes(props.taxiCompany);

  /** 乗車日時が12/19~03/31の間か？ */
  const isRideDateInMileCampaignPeriod = (): boolean => {
    if(!reservation) {
      return false;
    }
    const rideDate = parseFromyyyyMMddHHmm(reservation.rideDatetime);
    const startDate = toLuxonDateTime('2024-12-19T00:00:00.000+09:00');
    const endDate = toLuxonDateTime('2025-03-31T23:59:59.999+09:00');
    return rideDate >= startDate && rideDate <= endDate;
  }

  return (
    <>
      <Container maxWidth="md" style={{ marginTop: '20px' }}>
        {/* 本予約の処理実行中に表示する読込中アイコン。 */}
        <LoadingModal/>
        {/* タクシーロゴ表示部分。 */}
        <Grid container justify="center">
          <Grid item className={classes.imgContainer}>
            <ShowTaxiComapnyLogo
              company={props.taxiCompany}
              lang={changeLang(i18n.language)}
            />
          </Grid>
        </Grid>
        <Typography style={{ marginTop: "10px" }}>
          {t('taxi:input_reserved_info')}
        </Typography>
        <Grid container justify="center">
          <Grid item xs={3} className={classes.tableLeft}>
            <Typography className={classes.itemName}>
              { isToAirport ? t('taxi:pickup_location') : t('taxi:pickup_airport') }
            </Typography>
          </Grid>
          <Grid
            item
            xs={9}
            className={`${classes.tableRight} ${classes.tableFlex}`}
            data-cy={isToAirport? 'booking_taxi_pickup_location': 'booking_taxi_pickup_airport'}
          >
            <div>
              {/** To空港の場合にはお迎え先の情報をリンクで表示する */}
              {isToAirport &&
                <div className={classes.link}>
                  <Link href={setGoogleMapURL(reservation?.originLatLng, changeLang(i18n.language))} target="_blank">
                    {/* 出発地の名称。 */}
                    { reservation?.originLabel }
                  </Link>
                </div>
              }
              {/* From空港の場合注釈を表示する */}
              { !isToAirport &&
                <>
                  <div>
                    {/* 出発地の名称。 */}
                    { reservation?.originLabel }
                  </div>
                  <div className={classes.notes}>
                    {airportNoteLabel}
                  </div>
                </>
              }
            </div>
          </Grid>
          <Grid item xs={3} className={classes.tableLeft}>
            { isToAirport ? t('taxi:sending_airport') : t('taxi:sending_location') }
          </Grid>
          <Grid item xs={9} className={`${classes.tableRight} ${classes.tableFlex}`}>
            <Grid className={classes.date} data-cy={isToAirport? 'booking_taxi_sending_airport': 'booking_taxi_sending_location'}>
              {/** To空港の場合には空港名だけ表示する */}
              { isToAirport &&
                <div>
                  {/* 出発地の名称。 */}
                  { reservation?.destLabel }
                </div>
              }
              {/** From空港の場合にはお送り先の情報をリンクで表示する */}
              { !isToAirport &&
                <div className={classes.link}>
                  <Link href={setGoogleMapURL(reservation?.destLatLng, changeLang(i18n.language))} target="_blank">
                    {/* 到着地の名称。 */}
                    { reservation?.destLabel }
                  </Link>
                </div>
              }
            </Grid>
          </Grid>
          {/* ご乗車日時。 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {isFlightConnectionSharedTaxi ? (
              <>
                <div>乗合タクシー</div>
                <div>ご乗車日／接続する航空便</div>
              </>
            ) : (
              t('taxi:boarding_date')
            )}
          </Grid>
          <Grid item xs={9} className={`${classes.tableRight} ${classes.tableFlex}`}>
            <Grid className={classes.date}>
              <div data-cy={"booking_taxi_ride_date"}>
                {isFlightConnectionSharedTaxi ? (
                  <>
                    {rideDate()}
                    {reservation && <>&nbsp;{reservation.taxiConnectFlightNumber}</>}
                    {t('taxi:flight_after') + t('taxi:connect_taxi')}
                  </>
                ) : (
                  <>
                    {/* 仮予約時に設定した乗車日時。 */}
                    {rideDatetime()}
                    {isKisakataTaxi && <>{t('taxi:dep_taxi')}</>}
                  </>
                )}
              </div>
            </Grid>
          </Grid>
          {/* ご利用便。 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {isFlightConnectionSharedTaxi &&
              <>
                {t('taxi:flight_number_shonai_taxi')} { getFlightTimeLabel() }
              </>
            }
            {!isFlightConnectionSharedTaxi &&
              <>
                {t('taxi:flight_number')} { getFlightTimeLabel() }
              </>
            }
          </Grid>
          {/* 搭乗便 */}
          <Grid item xs={9} className={classes.tableRight} data-cy={"booking_taxi_flight_label"}>
            { `${flightNumber()} ${flightDate()} ` }
          </Grid>
          {/* 代表者の氏名。 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:representative_name')}
          </Grid>
          <Grid item xs={9} className={`${classes.tableRight}`}>
            <Grid container>
              <FormControl variant="outlined" className={`${classes.mailForm} ${classes.tableFlex}`}>
                {t('taxi:family_name')}
                <TextField
                  className={classes.mailText}
                  variant="outlined"
                  value={lastName}
                  onChange={(e: any) => {lastNameChange(e.target.value)}}
                  error={ (isEmptyLastName || isInvalidLastName) }
                  inputProps={{
                    style: {
                      padding: '3px',
                      fontSize: '0.75rem'
                    }
                  }}
                  FormHelperTextProps={{
                    style: {
                      margin: '8px 0 0',
                    }
                  }}
                />
                { (isEmptyLastName || isInvalidLastName) &&
                    <Alert severity="error" className={classes.validationAlert}>{getHelperTextLastName()}</Alert> }
              </FormControl>
              <FormControl variant="outlined" className={`${classes.mailForm} ${classes.tableFlex}`}>
                {t('taxi:first_name')}
                <TextField
                  className={classes.mailText}
                  variant="outlined"
                  value={firstName}
                  onChange={(e: any) => {firstNameChange(e.target.value)}}
                  error={ (isEmptyFirstName || isInvalidFirstName) }
                  inputProps={{
                    style: {
                      padding: '3px',
                      fontSize: '0.75rem'
                    }
                  }}
                  FormHelperTextProps={{
                    style: {
                      margin: '8px 0 0',
                    }
                  }}
                />
                { (isEmptyFirstName || isInvalidFirstName) &&
                    <Alert severity="error" className={classes.validationAlert}>{getHelperTextFirstName()}</Alert> }
              </FormControl>
            </Grid>
            {/** 日本語版のみ氏名のカナを入れる欄を追加する */}
            { changeLang(i18n.language) === Lang.ja &&
              <Grid container data-cy={"booking_taxi_kana_input"}>
                <FormControl variant="outlined" className={`${classes.mailForm} ${classes.tableFlex}`}>
                  セイ（全角カナ）
                  <TextField
                    className={classes.mailText}
                    variant="outlined"
                    value={lastNameKana}
                    onChange={(e: any) => {onChangedLastNameKana(e.target.value)}}
                    error={ (isEmptyLastNameKana || isInvalidLastNameKana) }
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 0',
                      }
                    }}
                  />
                  { (isEmptyLastNameKana || isInvalidLastNameKana) &&
                      <Alert severity="error" className={classes.validationAlert}>{getHelperTextLastNameKana()}</Alert> }
                </FormControl>
                <FormControl variant="outlined" className={`${classes.mailForm} ${classes.tableFlex}`}>
                  メイ（全角カナ）
                  <TextField
                    className={classes.mailText}
                    variant="outlined"
                    value={firstNameKana}
                    onChange={(e: any) => {onChangedFirstNameKana(e.target.value)}}
                    error={ (isEmptyFirstNameKana ||isInvalidFirstNameKana) }
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 0',
                      }
                    }}
                  />
                  { (isEmptyFirstNameKana ||isInvalidFirstNameKana) &&
                      <Alert severity="error" className={classes.validationAlert}>{getHelperTextFirstNameKana()}</Alert> }
                </FormControl>
              </Grid>
            }
          </Grid>
            <Grid item xs={3} className={classes.tableLeft}>
              {t('taxi:placard_name')}
            </Grid>
            <Grid item xs={9} className={classes.tableRight}>
              {/** supportPlacardName 属性がある場合のみプラカード欄を入力できるようにする。 */}
              {props.taxiCompanyConf && props.taxiCompanyConf.supportPlacardName &&
                <FormControl variant="outlined" className={classes.mailForm}>
                  <TextField
                    className={classes.mailText}
                    variant="outlined"
                    value={placard}
                    onChange={(e: any) => {onChangedPlacard(e.target.value)}}
                    error={ (isTooLongPlacard) }
                    fullWidth
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 8px',
                      }
                    }}
                  />
                  { (isTooLongPlacard) &&
                        <Alert severity="error" className={classes.validationAlert}>{getHelperTextPlacard()}</Alert> }
                  <span className={classes.notes}>{t('taxi:placard_name_notice')}</span>
                </FormControl>
              }
              {/** プラカード欄（入力不可） */}
              {props.taxiCompanyConf && !props.taxiCompanyConf.supportPlacardName &&
                <FormControl variant="outlined" disabled={true} className={classes.mailForm}>
                  <TextField
                    className={classes.disableMaileTaxt}
                    variant="outlined"
                    fullWidth
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 8px',
                      }
                    }}
                    disabled={true}
                  />
                  <span className={classes.notes}>{t('taxi:not_surrport_placard')}</span>
                </FormControl>
              }
            </Grid>
          {/* 連絡先。 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:phone_number')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight}>
            <FormControl variant="outlined" className={classes.mailForm}>
              <TextField
                className={classes.mailText}
                variant="outlined"
                value={phoneNumber}
                onChange={(e: any) => {phoneNumberChange(e.target.value)}}
                error={ (isEmptyPhoneNumber || isInvalidPhoneNumber) }
                fullWidth
                inputProps={{
                  style: {
                    padding: '3px',
                    fontSize: '0.75rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    margin: '8px 0 8px',
                  }
                }}
              />
              { (isEmptyPhoneNumber || isInvalidPhoneNumber) &&
                <Alert severity="error" className={classes.validationAlert}>{getHelperTextPhoneNumber()}</Alert> }
              <Typography className={classes.notes}>{t('taxi:phone_number_notice')}</Typography>
            </FormControl>
          </Grid>
          {/* 車種。 */}
          { isDisplayCarModel(props.taxiCompany) &&
            <>
              <Grid item xs={3} className={classes.tableLeft}>
                {t('taxi:desired_car_model')}
              </Grid>
              <Grid item xs={9} className={classes.tableRight}>
                <div data-cy={"booking_taxi_desired_car_model"}>
                  {/** 宮交の場合にはスペシャルな注意事項を出す */}
                  { props.taxiCompany === TaxiCompanyList.miyakou &&
                    <div className={classes.notes}>
                      本フォームでご予約いただける車種は普通車のみとなります。<br/>
                      普通車以外をご希望の場合は、<br/>
                      お手数ですが宮交タクシーへ直接お問い合わせください。
                    </div>
                  }
                  {/* 網走ハイヤーの場合ラベルを追加する */}
                  {props.taxiCompany === TaxiCompanyList.abashiri &&
                    <div>
                      普通車(車種をお選びください)
                    </div>
                  }
                  <FormControl component="fieldset">
                    <RadioGroup aria-label="car-type" name="car-type" value={carType}>
                      {/** 選択可能車種をメタ情報を元に表示 */}
                      { ui.carTypes.map((getCarType, index)=>{
                        return (
                          <FormControlLabel
                            value={getCarType.id}
                            label={
                              <Typography className={classes.text}>{getCarType.label}</Typography>
                            }
                            control={
                              <Radio size='small' onClick={
                                () => {
                                  setCarType(getCarType.id);
                                  setFareAndLabelsByCarType(getCarType.id);
                                }
                              }/>
                            }
                            key={index}
                          />
                        )
                      }) }
                    </RadioGroup>
                  </FormControl>

                  {/** つばめタクシーの場合には専用ラベルを表示する */}
                  {props.taxiCompany === TaxiCompanyList.tsubame &&
                    <div className={classes.notes}>
                      ※ご予約人数にかかわらず、車種は当日の配車状況に基づき決定いたします。<br/>
                      ※事前の車種のご指定は承っておりません。
                    </div>
                  }
                  {/** つばめハイヤーの場合には専用ラベルを表示する */}
                  {props.taxiCompany === TaxiCompanyList.tsubamelimo &&
                    <>
                      <div>
                        {/* 表示できないダミーのラジオ */}
                        {["クラウン（最大3名）", "アルファード（最大6名）", "グランエース（最大6名）", "ハイエース（最大9名）"].map((label, index) => (
                          <div key={index}>
                            ・{label}
                          </div>
                        ))}
                      </div>
                      <div className={classes.notes}>
                        ※ご予約人数にかかわらず、車種は当日の配車状況に基づき決定いたします。<br/>
                        ※事前の車種のご指定は承っておりません。
                      </div>
                    </>
                  }
                  {/** 車種が復数かつ車種によって金額が異なる場合の注釈を表示する */}
                  { isShowNotesByDifferenceOfTariffs &&
                    <div className={classes.notes}>
                      {t('taxi:desired_car_model_notice')}
                    </div>
                  }
                </div>
              </Grid>
            </>
          }
          {/* 利用人数。 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:user_num')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight}>
            <div className={classes.tableFlex}>
              <div>
                {t('taxi:adult')}<br/>
                <FormControl variant="outlined" className={classes.formControl} style={{marginTop: '0.3rem'}}>
                  <SelectAdultNum value={adultNum} onChange={onChangeAdultNum} />
                  <Typography className={classes.text}>
                    {t('taxi:num')}
                  </Typography>
                </FormControl>
              </div>
              <div style={{ marginLeft: '1rem' }}>
                {t('taxi:child')}<br/>
                <FormControl variant="outlined" className={classes.formControl} style={{marginTop: '0.3rem'}}>
                  <SelectChildrenNum value={childNum} onChange={onChangeChildNum} />
                  <Typography className={classes.text}>
                    {t('taxi:num')}
                  </Typography>
                </FormControl>
              </div>
            </div>
            { props.taxiCompany === TaxiCompanyList.nikaho_go &&
              <div className={classes.notes} style={{ marginTop: '0.3rem'}}>
                ※幼児から大学生は学割料金（1,000円）但し適用日限定・公的証明書の提示必須<br/>
                詳しくは、にかほGOウェブサイト（https://www.nikaho-kanko.jp/nikahogo.html）にてご確認ください
              </div>
            }
            { props.taxiCompany === TaxiCompanyList.airport_liner &&
              <div className={classes.notes} style={{ marginTop: '0.3rem'}}>
                ※現地でのお支払い時、子供は半額となります。
              </div>
            }
            { isShonaiAreaTaxi &&
              <div className={classes.notes} style={{ marginTop: '0.3rem'}}>
                ※現地でのお支払い時、小学生は半額となります。
              </div>
            }
          </Grid>
          {/** 台数: 特定の事業者の場合は表示しない */}
          { isDisplayNumberOfCars(props.taxiCompany) &&
            <>
              <Grid item xs={3} className={classes.tableLeft}>
                {t('taxi:number_of_cars')}
              </Grid>
              <Grid item xs={9} className={classes.tableRight}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <SelectCarNum value={carNum} onChange={onChangeCarNum} />
                  <Typography className={classes.text}>
                    {carNum > 1? t('taxi:numbers_car'): t('taxi:number_car')}
                  </Typography>
                </FormControl>
              </Grid>
            </>
          }
          {/** 大きなお荷物 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:big_baggage')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight}>
            {/** 選択可能荷物をメタ情報を元に表示 */}
            { ui.bags.map((bag, index)=>{
              const SetSelectArea: React.FC = () => {
                switch(bag.id) {
                  case 'suitcase':
                    return (
                      <SelectSuitcase
                        value={suitcase}
                        onChange={onChangeSuitcase}
                        maxNum={maxSuitcase}
                      />
                    );
                  case 'golfBag':
                    return (
                      <SelectGolfBag
                        value={golfBag}
                        onChange={onChangedGolfBag}
                        maxNum={maxGolfBag}
                      />
                    );
                  default:
                    return (
                      <SelectOtherBag
                        value={otherBag}
                        maxOtherBag={bag.maxQuantity || 9}
                        onChange={onChangeOtherBag}
                      />
                    )
                }
              }
              return (
                <FormControl variant="outlined" className={classes.formControl} key={index}>
                  <Typography className={classes.text} style={{marginRight: '0.3rem'}}>
                    {bag.label}
                  </Typography>
                  <SetSelectArea/>
                  <Typography className={classes.text} style={{marginRight: '0.3rem'}}>
                    {t('taxi:number_bag')}
                  </Typography>
                </FormControl>
              )
            }) }
            <div className={classes.notes}>
              {/** 選べる車種が1種類のときだけこちらのメッセージを表示する */}
              { props.taxiCompanyConf?.ui?.carTypes && Object.keys(props.taxiCompanyConf.ui.carTypes).length === 1 &&
                <>
                  {t('taxi:bigbag_notice_1')}<br/>
                </>
              }
              {t('taxi:bigbag_notice_2')}
            </div>
          </Grid>
          {/** お支払い方法 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:pay_method')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight} data-cy={"booking_taxi_payment"}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="payment"
                name="payment"
                value={payment}
                onChange={(e: any) => {paymentChange(e.target.value)}}
              >
                {/** 選択可能決済手段をメタ情報を元に表示 */}
                { ui.paymentMethod.map((pay, index) => {
                  return (
                    <FormControlLabel
                      value={pay.id}
                      control={<Radio />}
                      label={
                        <Typography className={classes.text}>{pay.label}</Typography>
                      }
                      key={index}
                    />
                  )
                })}
              </RadioGroup>
            </FormControl>
            <Typography className={classes.notes}>
              {t('taxi:pay_notice')}
            </Typography>
          </Grid>
          {/* タクシーメタ情報を元にして、ACM(マイレージ情報)がtrueの時には入力欄を設ける */}
          { isDisplayAMCInputTable() &&
            <>
              <Grid item xs={3} className={classes.tableLeft}>
                {t('taxi:ana_mileage_club_number')}
              </Grid>
              <Grid item xs={9} className={classes.tableRight} data-cy={"booking_taxi_mileage_club_area"}>
                <FormControl variant="outlined" className={classes.mailForm}>
                  <TextField
                    className={classes.mailText}
                    variant="outlined"
                    value={acmMileageNumber}
                    onChange={(e: any) => {setAcmMileageNumber(e.target.value)}}
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    error={isInvalidACMNumber}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 8px',
                      }
                    }}
                  />
                  {/* 【AM-1152】キャンペーン期間中はマイル増量の案内テキスト＋説明PDFリンクを表示する。 */}
                  { isInMileageCampaign &&
                    <Typography className={classes.notes} style={{ marginTop: '0.3rem'}}>
                      {CURRENT_MILEAGE_CAMPAIGN.text.leadText}<br/>
                      詳細は
                      <Link
                        href={getMileageCampaignPdfUrl(isMileageOriginalSupported)}
                        target="_blank"
                        className={classes.link}
                      >
                        こちら
                      </Link>
                      にてご確認ください。
                    </Typography>
                  }
                  {/* ANAマイレージクラブ会員番号に数字以外が含まれている場合の警告。 */}
                  { isInvalidACMNumber &&
                    <Alert severity="error" className={classes.validationAlert}>{t('taxi:ana_mileage_club_notice')}</Alert>
                  }
                </FormControl>
              </Grid>
            </>
          }
          {/** 領収書宛名 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:receipt_name')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight}>
            <FormControl variant="outlined" className={classes.mailForm}>
              <TextField
                className={classes.mailText}
                variant="outlined"
                value={receiptAddress}
                onChange={(e: any) => {receiptAddressChange(e.target.value)}}
                fullWidth
                inputProps={{
                  style: {
                    padding: '3px',
                    fontSize: '0.75rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    margin: '8px 0 8px',
                  }
                }}
              />
            </FormControl>
          </Grid>
          {/** 備考 */}
          <Grid item xs={3} className={classes.tableLeft}>
            {t('taxi:remarks')}<br/>
            {t('taxi:remarks_notice')}
          </Grid>
          <Grid item xs={9} className={classes.tableRight}>
            <FormControl variant="outlined" className={classes.mailForm} style={{ width: '70%' }}>
              <TextField
                className={classes.mailText}
                variant="outlined"
                value={remarks}
                error={isTooLongRemarks}
                onChange={(e: any) => {remarksChange(e.target.value)}}
                fullWidth
                multiline
                rows={2}
                inputProps={{
                  style: {
                    padding: '3px',
                    fontSize: '0.75rem'
                  }
                }}
                FormHelperTextProps={{
                  style: {
                    margin: '8px 0 8px',
                  }
                }}
              />
              {/* エアポートライナーの場合*/}
              { props.taxiCompany === TaxiCompanyList.airport_liner &&
                <Typography className={classes.notes}>
                  ※車いすご利用の場合は、その旨ご記入ください
                </Typography>
              }

            { (isTooLongRemarks) &&
              <Alert severity="error" className={classes.validationAlert}>{getHelperTextRemarks()}</Alert>
            }
            </FormControl>
          </Grid>
          {/* dev, staging環境でのみ、タクシー会社のメールアドレスとして扱うメールアドレスを設定できる欄を表示する。 */}
          { (Environment.isDev(env) || Environment.isStaging(env)) &&
            <>
              <Grid item xs={3} className={classes.tableLeft}>
                タクシー会社のメールアドレスとして扱うメールアドレス
              </Grid>
              <Grid item xs={9} className={classes.tableRight}>
                <FormControl variant="outlined" className={classes.mailForm} style={{ width: '70%' }}>
                  <TextField
                    className={classes.mailText}
                    variant="outlined"
                    value={operatorMailaddress}
                    onChange={(e: any) => {onChangedOperatorMailaddress(e.target.value)}}
                    error={ isInvalidOperatorMailaddress }
                    helperText={ isInvalidOperatorMailaddress && "不正なメールアドレスです。"}
                    fullWidth
                    inputProps={{
                      style: {
                        padding: '3px',
                        fontSize: '0.75rem'
                      }
                    }}
                    FormHelperTextProps={{
                      style: {
                        margin: '8px 0 8px',
                      }
                    }}
                  />
                  <Typography variant="caption">
                    ※開発・ステージング環境のみ表示<br/>
                    予約情報などのメールが指定したアドレスに送信される。
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={3} className={classes.tableLeft}>
                タクシーメール未送信への対応
              </Grid>
              <Grid item xs={9} className={classes.tableRight}>
                <FormControl variant="outlined">
                  <Select
                    onChange={(e: any) => {
                      setMailUndeliveredProblemReproduction(e.target.value)
                    }}
                    value={mailUndeliveredProblemReproduction}
                  >
                    <MenuItem value={""}>なし</MenuItem>
                    <MenuItem value={"bounce"}>バウンス(Bounce)</MenuItem>
                    <MenuItem value={"complaint"}>苦情(Complaint)</MenuItem>
                    <MenuItem value={"suppressionlist"}>suppressionlist</MenuItem>
                  </Select>
                  <Typography variant="caption">
                    bounce: メールがバウンスされた状態を再現<br/>
                    complaint: メール受信者が「迷惑メール」としてプロバイダに報告した状態で、プロバイダが受信を拒否した状態を再現<br/>
                    suppressionlist: 当該アドレスに不着が頻発して、SESが送信しないリストに登録された状態を再現（挙動的にはbounceと同じ）<br/><br/>
                    ※開発・ステージング環境のみ表示<br/>
                    予約情報などのメールが指定したアドレスに送信される。
                  </Typography>
                </FormControl>
              </Grid>
            </>
          }
        </Grid>
        {/* 縦並びで料金表示部分・予約ボタンを表示する。 */}
        <Grid container direction="column">
          {/* 距離・時間・金額部分。 */}
          {/* 要お問い合わせの場合。 */}
          { reservationFare.priceType === 'ask' && <Cost label={t('taxi:notice_amount_details')} />}
          {/* 定額・メーター料金の場合。 */}
          { (reservationFare.priceType === 'fixed' || reservationFare.priceType === 'PAYG') && (
            <Cost label={
              <span data-cy="booking_taxi_cost_area">
                { costLabel() }
                {/* モバイルサイズ（画面幅960px未満）の場合は改行を入れる。 */}
                { isMobileSize && <br /> }
                {/* デスクトップサイズ（画面幅960px以上）の場合は空白を入れる。 */}
                { !isMobileSize && <>&nbsp;</> }
                {/* 料金ラベルを表示する */}
                <PriceLabel/>
                {/* 備考を表示する */}
                <NotesLabel/>
              </span>
            }
            />
          )}
          {/** アラート表示がある場合には掲載する */}
          { (reservation && reservation.transferInfo?.labels?.alertLabel) && reservation.transferInfo.labels.alertLabel.map((alert: AlertLabel, index: number)=>{
            if(alert.type === 'alert') {
              const severity = "warning";
              return (
                <Alert severity={severity} key={index}>
                  { alert.message }
                </Alert>
              )
            }
            else {
              return (
                <Grid className={classes.costNotice}>
                  {alert.message}
                </Grid>
              )
            }
          })}

          <Grid item>
            {/* 予約に失敗した場合はその旨の警告を表示する。 */}
            { isFailed && <AlertInReservation type="fail"/> }
            {/* 入力内容に不備がある場合はその旨の警告を表示する。 */}
            { isInvalidInput && <AlertInReservation type="input"/> }
            {/* 再試行が必要な場合はその旨の警告を表示する。 */}
            { isRequiredRetry && <AlertInReservation type="retry"/> }
            {/* 利用できないメールアドレスが設定されている場合はその旨の警告を表示する。 */}
            { isUnavalableEmail && <AlertInReservation type="email"/> }
          </Grid>
          <Grid item>
            {/* 予約・料金確認などのアクション用のボタン。 */}
            <YellowButton
              size="large"
              variant="contained"
              className={classes.button}
              endIcon={<ArrowForwardIosIcon/>}
              onClick={onSubmit}
              // デバッグモードの時は押せないようにする
              disabled={props.isDebug}
            >
              {t('taxi:process_reservation_button')}
            </YellowButton>
            {props.isDebug &&
              <Typography variant="caption" display="block" style={{marginTop: '0.5rem'}}>
                予約画面確認用のデバッグモードのため、予約ボタンは押せません
              </Typography>
            }
          </Grid>
          {/* 注意事項。 */}
          <Grid item>
            <Cautions
              isMeterFare={reservationFare.fareType === 'PAYG'}
              companyDisplayName={props.taxiCompanyConf?.temporaryDisplayName || ''}
              isSupportAMC={isDisplayAMCInputTable()}
              company={props.taxiCompany}
              isReservationPage
              isCampaignPeriod={isInMileageCampaign}
              isOriginalSupported={isMileageOriginalSupported}
            />
          </Grid>
          {/* 問い合わせ先。 */}
          <Grid item>
            <Contact
              company={props.taxiCompany}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default AirportTransferTaxi;
